<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">Predefined Report Expenses</h1>
            <p class="page-subtitle">Manage predefined expense items for reporting</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">Loading expenses...</p>
    </div>

    <div class="card" [class.loading]="isLoading">
        <div class="card-header">
            <div class="header-icon">
                <mat-icon>receipt_long</mat-icon>
            </div>
            <div class="header-text">
                <h2 class="card-title">Expense List</h2>
                <p class="card-subtitle">View and manage all predefined expense items</p>
            </div>
        </div>

        <div class="card-body">
            <div class="actions-bar">
                <div class="search-wrapper">
                    <mat-icon class="search-icon">search</mat-icon>
                    <input
                        type="text"
                        class="search-input"
                        [(ngModel)]="searchText"
                        placeholder="Search by account, description, or class..."
                    />
                </div>
                <button type="button" class="btn-add" (click)="addNewReportData()">
                    <mat-icon>add</mat-icon>
                    <span>Add Expense</span>
                </button>
            </div>

            <div class="table-container" *ngIf="filteredOrders.length > 0">
                <table class="data-table">
                    <thead>
                        <tr>
                            <th>Expense Account</th>
                            <th>Description</th>
                            <th>Amount</th>
                            <th>Class</th>
                            <th class="actions-column">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of filteredOrders">
                            <td class="account-cell">{{ data.expenseAccount }}</td>
                            <td>{{ data.expenseDesc }}</td>
                            <td class="amount-cell">${{ data.expenseAmount }}</td>
                            <td class="class-cell">{{ data.expenseClass }}</td>
                            <td class="actions-cell">
                                <button class="action-btn" (click)="onEditAction(data)">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <div *ngIf="selectedDriverId === data.id" class="action-menu">
                                    <button class="menu-item" (click)="onEdit(data)">
                                        <mat-icon>edit</mat-icon>
                                        <span>Edit</span>
                                    </button>
                                    <button class="menu-item delete" (click)="onDelete(data)">
                                        <mat-icon>delete</mat-icon>
                                        <span>Delete</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="empty-state" *ngIf="filteredOrders.length === 0">
                <mat-icon class="empty-icon">receipt_long</mat-icon>
                <h3>No expenses found</h3>
                <p *ngIf="searchText">Try adjusting your search criteria</p>
                <p *ngIf="!searchText">Add your first expense item to get started</p>
            </div>

            <div class="pagination" *ngIf="totalPages > 1">
                <button class="page-btn" [disabled]="currentPage === 1" (click)="getReportList(currentPage - 1)">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <button
                    *ngFor="let page of pages"
                    class="page-btn"
                    [class.active]="page === currentPage"
                    (click)="getReportList(page)"
                >
                    {{ page }}
                </button>
                <button class="page-btn" [disabled]="currentPage === totalPages" (click)="getReportList(currentPage + 1)">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
